import { lazy } from 'react';
import { screenOptionsForLightMode } from '../../../../functions/navigation/screenOptions';
import { wrapLazyNavigatorScreen } from '../../../../functions/navigation/utils/wrapNavigatorScreen';
const StateSelectPageContent = lazy(
  () => import('../components/StateSelectPageContent'),
);

export const StateSelectPage = wrapLazyNavigatorScreen(
  StateSelectPageContent,
  screenOptionsForLightMode({
    title: 'Select State',
  }),
);
